var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreparing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7626 19.26C18.3501 20.3175 17.3451 21 16.2126 21H11.7876C10.6476 21 9.65011 20.3175 9.23761 19.26C8.82511 18.195 9.11011 17.0175 9.95011 16.2525L12.9876 13.5H15.0201L18.0501 16.2525C18.8901 17.0175 19.1676 18.195 18.7626 19.26Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.365 18.105H12.635C12.35 18.105 12.125 17.8725 12.125 17.595C12.125 17.31 12.3575 17.085 12.635 17.085H15.365C15.65 17.085 15.875 17.3175 15.875 17.595C15.875 17.8725 15.6425 18.105 15.365 18.105Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7625 7.74C18.35 6.6825 17.345 6 16.2125 6H11.7875C10.655 6 9.65 6.6825 9.2375 7.74C8.8325 8.805 9.11 9.9825 9.9575 10.7475L12.9875 13.5H15.02L18.05 10.7475C18.89 9.9825 19.1675 8.805 18.7625 7.74ZM15.365 9.9225H12.635C12.35 9.9225 12.125 9.69 12.125 9.4125C12.125 9.135 12.3575 8.9025 12.635 8.9025H15.365C15.65 8.9025 15.875 9.135 15.875 9.4125C15.875 9.69 15.6425 9.9225 15.365 9.9225Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparing);
export default __webpack_public_path__ + "static/media/preparing.dfe86f8df2ffaad23c4014e9dc79538b.svg";
export { ForwardRef as ReactComponent };